import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuoteSection from './components/QuoteSection';
import FeaturesSections from './components/FeaturesSections';
import PricingSection from './components/PricingSection';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 overflow-x-hidden">
      <Navbar />
      <Hero />
      <QuoteSection />
      <div id="benefits-section">
        <FeaturesSections />
      </div>
      <div id="pricing-section">
        <PricingSection />
      </div>
      <CallToAction />
      <Footer />
    </div>
  );
}

export default App; 